import { useTranslator } from '@bluebeam/react-i18n';
import LoadingAnimation from 'components/LoadingAnimation';
import ModalStdHeader from 'components/modals/ModalStdHeader';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import {
  CalibrationMachineStatesEnum,
  useCalibrationMachine,
} from './CalibrationMachine';
import SheetAligner from './SheetAligner';
import SheetCropper from './SheetCropper';
import SheetScaler from './SheetScaler';

const CalibrationModalContent: React.FC = () => {
  const { translate } = useTranslator(['mapView']);
  const { actions } = useContext(AppStoreContext);

  const { calibrationMachineState } = useCalibrationMachine();

  const cancel = () => {
    actions.clearAllModals();
  };

  const renderCalibrationStep = () => {
    if (calibrationMachineState.matches(CalibrationMachineStatesEnum.scaling)) {
      return <SheetScaler />;
    }
    if (
      calibrationMachineState.matches(CalibrationMachineStatesEnum.aligning)
    ) {
      return <SheetAligner />;
    }
    if (
      calibrationMachineState.matches(CalibrationMachineStatesEnum.cropping)
    ) {
      return <SheetCropper />;
    }
    if (calibrationMachineState.matches(CalibrationMachineStatesEnum.done)) {
      cancel();
    }
    if (
      calibrationMachineState.matches(
        CalibrationMachineStatesEnum.selectingDrawing
      )
    ) {
      actions.popModal();
    }
    return (
      <LoadingAnimation
        pageName={translate('mapView:calibrationModalContent.loadingDrawing')}
      />
    );
  };

  return (
    <div id="calibration-modal" className="modal__content">
      <ModalStdHeader
        text={translate('mapView:calibrationModalContent.prepareDrawing')}
      />
      <div className="h100 pt7 column">{renderCalibrationStep()}</div>
    </div>
  );
};

export default CalibrationModalContent;
